<!-- sport_tab Start -->
<div class="sport_tab">
    <ul class="nav nav-tabs">
        <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" [routerLink]="['/dashboard']" routerLinkActive="active"><i class="fa-solid fa-home"></i> home</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" routerLink="/sports/inplay" routerLinkActive="active"><i class="fa-solid fa-play"></i> inplay</a>
        </li>
        <li class="nav-item" *ngFor="let item of menu;">
            <!-- all available sports and races -->
            <a *ngIf="!events.casino.includes(item.id)" class="nav-link" href="javascript:void(0)" [routerLink]="['/sports',item?.id]" routerLinkActive="active">
                <i class="nav-icon fa-duotone " *ngIf="item.id == 1 || item.id == 2 || item.id == 4 || item.id == 7 || item.id == 4339" [ngClass]="{
                    'fa-football': item.id==1, 
                    'fa-tennis-ball':item.id==2,
                    'fa-cricket-bat-ball':item.id==4, 
                    'fa-horse':item.id==7,
                    'fa-dog':item.id==4339
                }"></i>
                <img *ngIf="item.id != 1 && item.id != 2 && item.id != 4 && item.id != 7 && item.id != 4339" class="img-fluid" src="https://speedcdn.io/assets/parker-client/icons/{{item.id}}.svg">
                {{item?.name}}
            </a>
            <!-- all available casino -->
            <a *ngIf="events.casino.includes(item.id)" class="nav-link" href="javascript:void(0)" [routerLink]="['/casino',item?.id]" routerLinkActive="active">
                <i class="nav-icon fa-duotone" [ngClass]="{
                    'fa-coin': item.id==99999, 
                    'fa-slot-machine': item.id==99995, 
                    'fa-coins': item.id==99998
                }"></i>
                {{item?.name}}
            </a>
        </li>
        <li class="nav-item" *ngIf="isLogin()">
            <a class="nav-link" href="javascript:void(0)" routerLink="/event/multi-market" routerLinkActive="active"> 
                <i class="nav-icon fa-duotone fa-chart-tree-map"></i>
                Multi Market
            </a>
        </li>
    </ul>
</div>
<!--/ sport_tab End -->

<div class="mob-dw d-sm-none d-flex">
    <li class="nav-item btns__deposit_withdrawal d-desktop-none" *ngIf="depoWithdrawCondition()">
        <button class="nav-link btn btn-block btn-gradient-primary btn-sm font-weight-medium auth-form-btn  btn_deposit" routerLink="/deposit">
            <img src="https://speedcdn.io/assets/diamond-client-v8/deposit-icon.webp" class="img-fluid"> deposit
        </button>
    </li>
    <li class="nav-item btns__deposit_withdrawal d-desktop-none" *ngIf="depoWithdrawCondition()">
        <button class=" nav-link btn btn-block btn-gradient-primary btn-sm font-weight-medium auth-form-btn btn_withdrawal"  routerLink="/withdraw">
            <img src="https://speedcdn.io/assets/diamond-client-v8/withdrawal-icon.webp" class="img-fluid"> withdrawal
        </button>
    </li>
</div>